import React from 'react';

class SearchDivider extends React.Component {

  render() {
    return (
      <h3 className='ui horizontal divider tiny header'>
         <i
           style={{color: `${this.props.channel.color}`}}
           className={`${this.props.channel.logo} icon`}></i>
         {this.props.channel.name}
      </h3>
    );
  }

}

export default SearchDivider;



// WEBPACK FOOTER //
// ./src/components/SearchDivider.js